module.exports = __webpack_public_path__ + "static/media/18-server.f0c77800.svg";